
import { BASE_URL } from '@/common/constant';
import { IImage } from '@/common/interface';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { v4 } from 'uuid';
import {
  Vue,
  Component,
  Watch,
  Prop,
  Model,
  Emit,
} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import SPUService from '@/services/spu.service';
import { DebounceTime } from '@/common/decorator';

@Component({
  components: { draggable },
})
export default class HeadlineImagesField extends Vue {
  val: IImage[] = [];

  uploading = false;

  BASE_URL = BASE_URL;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  token: string | undefined = undefined;

  viewImageSource = '';

  viewImageVisible = false;

  uuid = v4;

  max = 9;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  fieldOpts?: { max: number };

  @Model()
  value!: IImage[];

  @Prop()
  form!: any;

  oldId = 0;

  objDate: any = {};

  objPhoto: any = [];

  changeKey: any = '';

  radioValue = 0;

  @Watch('fieldOpts', { deep: true })
  watchFieldOpts() {
    if (this.fieldOpts && this.fieldOpts.max) {
      this.max = this.fieldOpts.max;
    }
  }

  @Watch('value')
  watchValue() {
    if (this.value.length) {
      this.val = [...this.value];
    } else {
      this.val = [];
    }
  }

  @Emit('update')
  updateVal() {
    return this.val;
  }

  @DebounceTime()
  @Watch('form.category')
  async watchCategory() {
    if (!this.form) {
      return;
    }
    console.log('watchCategory', this.form);
    if (this.oldId !== this.form.category.id) {
      this.oldId = this.form.category.id;
      const { category } = this.form;
      const res: any = await this.spuService.getSpuCategoryPhotoDelete(
        category.id,
      );
      const findDefaultItem = (obj: any): { is_default: 1 } | null => {
        if (!obj || typeof obj !== 'object') return null;
        const values = Object.values(obj).filter(Array.isArray).flat();
        return (
          values.find(
            (item): item is { is_default: 1 } =>
              item != null && typeof item === 'object' && item.is_default === 1,
          ) || null
        );
      };
      if (Object.prototype.toString.call(res) === '[object Object]') {
        const keys = Object.keys(res) as string[];
        const re = JSON.parse(JSON.stringify(res));
        const defaultItem: any = findDefaultItem(re);
        if (defaultItem && !this.form.id) {
          const { url, resource_id } = defaultItem;
          const img: IImage[] = [
            {
              id: resource_id,
              url,
            },
          ];
          console.log('this.val', this.val, img);
          this.val = [...img];
          this.updateVal();
          this.radioValue = resource_id;
        }
        this.objPhoto = keys;
        this.changeKey = defaultItem
          ? defaultItem.photo_type_name
          : keys[0] || '';
        this.objDate = res;
      } else {
        // this.val = { id: 0, url: '' };
        if (!this.form.id) {
          this.val = [];
        }
        this.objPhoto = [];
        this.changeKey = '';
        this.objDate = {};
      }
    }
  }

  @lazyInject(UserService)
  protected userService!: UserService;

  get uploaderVisible() {
    if (!this.val || !this.val.length || this.val.length < this.max) {
      return true;
    }
    return false;
  }

  onFileSuccess(rootFile: File, file: File, json: string) {
    this.val.push(JSON.parse(json).data[0]);
    this.updateVal();
  }

  funChange(item: any) {
    this.changeKey = item;
  }

  onRadioChange(e: any) {
    const id = e;
    const data = this.objDate[this.changeKey];
    const photo = data.find((item: any) => item.resource_id === id);
    const { url, resource_id } = photo;
    const result = {
      id: resource_id,
      url,
    };
    if (this.val.some((item) => item.id === result.id)) {
      return this.$message.error('图片已存在');
    }
    if (this.uploaderVisible) {
      this.val.push(result);
      this.updateVal();
      this.radioValue = id;
      console.log(photo);
    } else {
      this.$message.error('图片数量已达上限');
    }
  }

  async onFileError(rootFile: File, file: File, json: string) {
    const { code, error } = JSON.parse(json);
    if (code === 400) {
      this.$message.error(error);
      await $delay(1000);
      this.$router.push({
        path: '/login',
        query: {
          redirect: this.$route.fullPath,
        },
      });
    } else {
      this.$message.error(error);
    }
  }

  viewImage(src: string) {
    this.viewImageSource = src;
    this.viewImageVisible = true;
  }

  setCoverImg(index: number) {
    const list = [...this.val];
    const head = list.splice(index, 1);
    list.unshift(head[0]);
    this.val = [...list];
    this.updateVal();
  }

  delImage(index: number) {
    const list = [...this.val];
    list.splice(index, 1);
    this.val = [...list];
    this.updateVal();
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  mounted() {
    this.watchValue();
    this.watchCategory();
  }
}
